/** @format */

import {
	ChangeDetectionStrategy,
	Component,
	computed,
	HostListener,
	inject,
	OnInit,
	output,
	signal
} from '@angular/core';
import { Store } from '@ngrx/store';
import { selectAddToCartButtonText } from './+state/multi-add-to-cart-button.selector';
import {
	addToCartTriggered,
	selectSelectedBundlePruductsPrices,
	selectBundleProductsDataPartNumbers,
	selectSelectedBundleSkusPartNumbers
} from '@pdp/data-access/state';
import { UtilityService, WINDOW } from '@shared/data-access/services';
import { CurrencyPipe, DOCUMENT } from '@angular/common';
import { ATC_BUTTON_TEXTS } from '@pdp/add-to-cart/data-access';
import { HmfButtonComponent } from '@dsg-tech/homefield-angular';

@Component({
	selector: 'pdp-multi-add-to-cart-button',
	templateUrl: './multi-add-to-cart-button.component.html',
	styleUrl: './multi-add-to-cart-button.component.scss',
	providers: [CurrencyPipe],
	imports: [HmfButtonComponent],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class MultiAddToCartButtonComponent implements OnInit {
	private readonly store = inject(Store);
	private readonly utilityService = inject(UtilityService);
	protected readonly window = inject(WINDOW);
	private readonly document = inject(DOCUMENT);
	private readonly currencyPipe = inject(CurrencyPipe);

	addToCartButtonText = this.store.selectSignal(selectAddToCartButtonText);
	bundlePrice = this.store.selectSignal(selectSelectedBundlePruductsPrices);

	buttonTextWithOptionalPrice = computed(() => {
		const buttonText = this.addToCartButtonText().addToCartButtonText;
		const bundlePrice = this.bundlePrice();

		if (bundlePrice > 0 && buttonText === ATC_BUTTON_TEXTS.atc) {
			return `${buttonText} | ${this.currencyPipe.transform(bundlePrice)}`;
		}
		return buttonText;
	});

	storeSelectionReady = signal(false);

	allProductSkus = this.store.selectSignal(selectBundleProductsDataPartNumbers);
	selectedBundleSkus = this.store.selectSignal(selectSelectedBundleSkusPartNumbers);

	atcButtonTexts = ATC_BUTTON_TEXTS;

	public showAddToBundleError = output<boolean>();

	ngOnInit() {
		if (window.headerFunctions?.storeSelection) {
			this.storeSelectionReady.set(true);
		}
	}

	addToCartButtonClicked(buttonType: string, buttonAction: string) {
		if (buttonAction === 'SelectOptions') {
			this.showAddToBundleError.emit(true);
			this.utilityService.scrollToElement(
				this.document.getElementById('attributes-v2-container'),
				{
					behavior: 'smooth',
					block: 'center',
					inline: 'nearest'
				}
			);
		} else if (buttonType === ATC_BUTTON_TEXTS.noStoreSelected) {
			const storeSelectionValues = {
				skusArr: this.allProductSkus(),
				selectedSkuVal: this.selectedBundleSkus()
			};
			if (this.window.headerFunctions?.storeSelection) {
				this.window.headerFunctions.storeSelection(storeSelectionValues);
			}
		} else if (buttonType === ATC_BUTTON_TEXTS.atc) {
			this.store.dispatch(addToCartTriggered());
		}
	}

	@HostListener('window:HeaderServices:StoreSelection:Ready', ['$event'])
	public onStoreSelectionReady(customEvent: CustomEvent): void {
		if (customEvent) {
			this.storeSelectionReady.set(true);
		}
	}
}
